<div class="modal-container">
  <h3 id="header" class="ui primary header">
    {{ modal.context.title }}
    <img src="../../../../assets/icons/close.svg" alt="link times icon" (click)="modal.deny(undefined)">
  </h3>

  <div class="content">
    <div class="ui basic segment">
      <div
        class="flex row spacing field-row"
        style="box-sizing: border-box; align-items: center;"
      >
        <div style="width: 28%">
          <select class="ui fluid dropdown" [(ngModel)]="searchFilter.groupOp">
            <option *ngFor="let opt of groupOperators" [value]="opt.name">
              {{ opt.name }}
            </option>
          </select>
        </div>

        <div class="field" style="width: 28%">
          <select
            class="ui fluid dropdown"
            [formControl]="selectForm"
            (ngModelChange)="setSelectedFilter($event)"
          >
            <option *ngFor="let opt of headers" [ngValue]="opt">
              {{ opt.label }}
            </option>
          </select>
        </div>

        <div style="width: 28%">
          <button
            (click)="add()"
            class="ui basic button add-filter"
            style="outline: none;
            border: none;
            box-shadow: none;
            padding: 0;
            gap: 8px;
            display: flex;
            justify-content: space-between;
            align-items: center;"
          >
            <img src="../../../../assets/icons/add-filter.svg" alt="circular-plus-outline icon">
            <span>Add Filter</span>
          </button>
        </div>
      </div>
      <div class="ui form">
        <div
          style="margin: 3rem 0; padding-bottom: 1rem"
          class="flex row spacing field-row"
          style="box-sizing: border-box"
          *ngFor="let field of fieldx; let i = index; trackBy: trackByIndex"
        >
          <div style="width: 28%">
            <div class="field">
              <input type="text" [(ngModel)]="field.label" disabled />
            </div>
          </div>
          <div style="width: 28%">
            <div class="field">
              <select
                class="ui fluid dropdown"
                [(ngModel)]="field.op"
                type="text"
              >
                <option *ngFor="let opt of operators" [ngValue]="opt.id">
                  {{ opt.name }}
                </option>
              </select>
            </div>
          </div>
          <div style="width: 28%; flex-grow: 2">
            <div class="field" style="width: 100%">
              <input
                *ngIf="field.type === 'text'"
                type="text"
                placeholder="Enter text to search this field"
                [(ngModel)]="field.data"
              />
              <input
                *ngIf="field.type === 'number'"
                type="number"
                placeholder="Enter number to search this field"
                [(ngModel)]="field.data"
              />
              <select
                *ngIf="field.type === 'select'"
                class="ui fluid dropdown"
                [(ngModel)]="field.data"
              >
                <option
                  *ngFor="let opt of field.choices"
                  [ngValue]="opt.optionId"
                >
                  {{ opt.optionName }} {{ opt.optionDescription }}
                </option>
              </select>
              <input
                *ngIf="field.type === 'date'"
                type="date"
                suiDatepicker
                (ngModelChange)="field.data = $event"
                [ngModel]="field.data |  date:'medium'"
                />

            </div>
            <!--  <app-search-number-filter *ngIf="field.type === 'integer'" [field]="fieldx[i]"
                    [index]="i"></app-search-number-filter>
                  <app-search-text-filter *ngIf="field.type === 'text'" [field]="fieldx[i] "
                    [index]="i"></app-search-text-filter>
                  <app-search-select-filter (query)="changeOperators($event)" *ngIf="field.type === 'select'"
                    [field]="fieldx[i]" [index]="i"></app-search-select-filter>
                  <app-search-date-filter *ngIf="field.type === 'date'" [field]="fieldx[i] | dateTimeConverter"
                    [index]="i"></app-search-date-filter>
                 -->
          </div>
          <div fxFlex="10%" style="display: flex; align-items: center;">
            <!-- <div class="red-line"></div> -->
            <button
              style="box-shadow: none; padding: 0"
              class="ui basic button icon"
              (click)="remove(i)"
            >
              <i class="red minus icon" style="font-size: 25px;"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="actions text-right btns">
    <button class="ui primary basic button" (click)="modal.deny(undefined)">
      Cancel
    </button>
    <button (click)="submit()" class="ui primary button">Apply Filter</button>
  </div>
</div>
